<div class="dialog-content-wrapper">
    <!-- Header start -->
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            @if (action == "NEW") {
                <span class="title dialog-title">{{ "ALARM.NewAlarm" | translate }}</span>
            }
            @if (action == "EDIT") {
                <span class="title dialog-title">{{ "ALARM.AlarmDetail" | translate }}</span>
            }

            <div class="header-actions">
                @if (action == "NEW") {
                    <button mat-raised-button class="btn-save" color="primary" (click)="save()" [disabled]="alarmForm?.invalid" ngsw>
                        {{ "ALARM.ADD" | translate }}
                    </button>
                }
                @if (action == "EDIT") {
                    <button mat-raised-button class="btn-save" color="primary" (click)="save()" [disabled]="alarmForm?.invalid" ngsw>
                        {{ "ALARM.SAVE" | translate }}
                    </button>
                }
                <button mat-raised-button (click)="cancel()">
                    {{ "ALARM.CANCEL" | translate }}
                </button>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
    <!-- Header end -->

    <mat-dialog-content fusePerfectScrollbar>
        <form name="alarmForm" [formGroup]="alarmForm" class="alarm-form w-100-p" fxLayout="column" fxFlex>
            <div class="section">
                <h2 class="section__title">
                    <mat-icon>info</mat-icon>
                    <span>{{ "ALARM.AlarmDetail" | translate }}</span>
                </h2>
                <div class="row">
                    <!-- Name Input -->
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "ALARM.Name" | translate }}</mat-label>
                        <input matInput formControlName="name" placeholder="{{ 'ALARM.Name' | translate }}" type="text" />
                    </mat-form-field>

                    <!-- Field Select -->
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "ALARM.Field" | translate }}</mat-label>
                        <mat-select formControlName="field" placeholder="{{ 'ALARM.Field' | translate }}">
                            @for (field of alarmFields; track field) {
                                <mat-option [value]="field">
                                    {{ "FIELD." + field | translate }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Description Input -->
                <mat-form-field appearance="outline">
                    <mat-label>{{ "ALARM.Description" | translate }}</mat-label>
                    <textarea matInput name="description" formControlName="description" placeholder="{{ 'ALARM.Description' | translate }}">
                    </textarea>
                </mat-form-field>
            </div>

            <div class="section">
                <h2 class="section__title">
                    <mat-icon>tune</mat-icon>
                    <span>{{ "ALARM.Threshold" | translate }}</span>
                </h2>
                <div class="row">
                    <!-- Window select -->
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "ALARM.TimeWindow" | translate }}</mat-label>
                        <mat-select formControlName="window" placeholder="{{ 'ALARM.TimeWindow' | translate }}">
                            @for (window of windowValues; track window) {
                                <mat-option [value]="window">
                                    {{ "ALARM." + window | translate }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <!-- Threshold select -->
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "ALARM.Threshold" | translate }}</mat-label>
                        <mat-select formControlName="threshold" placeholder="'ALARM.Threshold' | translate">
                            @for (threshold of thresholdValues; track threshold) {
                                <mat-option [value]="threshold">
                                    {{ "ALARM." + threshold | translate }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="row">
                    @if (!usesPeriodLimits) {
                        <mat-form-field appearance="outline">
                            <mat-label>{{ "ALARM.Limit" | translate }}</mat-label>
                            <input matInput formControlName="limit" placeholder="{{ 'ALARM.Limit' | translate }}" type="number" />
                        </mat-form-field>
                    }
                </div>

                @if (hasProjectPeriods) {
                    <div class="alarm-limit-mode">
                        <div class="alarm-limit-mode__label">
                            {{ "ALARM.LimitMode" | translate }}
                        </div>

                        <mat-radio-group class="alarm-limit-mode__options" formControlName="limitMode">
                            <mat-radio-button [value]="alarmLimitMode.WholeDay">
                                {{ "ALARM.LimitModeWholeDay" | translate }}
                            </mat-radio-button>
                            <mat-radio-button [value]="alarmLimitMode.Periods">
                                {{ "ALARM.LimitModePeriods" | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                }

                @if (usesPeriodLimits) {
                    <div class="period-limit-grid" formArrayName="periodLimits">
                        @for (periodLimit of periodLimitsFormArray.controls; track $index) {
                            <div class="row" [formGroupName]="$index">
                                <mat-form-field appearance="outline" class="period-limit-field">
                                    <mat-label>Period</mat-label>
                                    <input matInput formControlName="periodName" type="text" disabled />
                                    <mat-hint>
                                        {{ getPeriodIntervalsLabel(periodLimit.get("periodName")?.value) }}
                                    </mat-hint>
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "ALARM.Limit" | translate }}</mat-label>
                                    <input matInput formControlName="limit" type="number" />
                                </mat-form-field>
                            </div>
                        }
                    </div>
                }

                <div class="row">
                    <!-- Severity -->
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "ALARM.Severity" | translate }}</mat-label>
                        <mat-select formControlName="severity" placeholder="Severity" required>
                            @for (severity of severityValues; track severity) {
                                <mat-option [value]="severity">
                                    {{ "SEVERITY." + severity | translate }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Ignored Devices -->
                @if (alarmType == "PROJECT") {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "ALARM.IgnoredDevices" | translate }}</mat-label>
                        <mat-select formControlName="ignoredDevices" placeholder="{{ 'ALARM.IgnoredDevices' | translate }}" multiple>
                            @for (device of projectDevices; track device) {
                                <mat-option [value]="device.id">
                                    {{ device.deviceName }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }
            </div>

            <div class="section">
                <h2 class="section__title">
                    <mat-icon>notifications</mat-icon>
                    <span>{{ "ALARM.Notification" | translate }}</span>
                </h2>

                <div class="checkbox-row">
                    <!-- Hidden -->
                    <mat-slide-toggle formControlName="silent">{{ "ALARM.Silent" | translate }}</mat-slide-toggle>

                    <!-- ACK -->
                    <mat-slide-toggle formControlName="needACK">{{ "ALARM.NeedACK" | translate }}</mat-slide-toggle>

                    <!-- Notify -->
                    @if (user.isAdmin) {
                        <mat-slide-toggle formControlName="notify">{{ "ALARM.Notify" | translate }}</mat-slide-toggle>
                    }
                </div>

                <!-- Notification List -->
                @if (user.isAdmin) {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "ALARM.NotificationChannels" | translate }}</mat-label>
                        <mat-select formControlName="notificationChannelIds" multiple>
                            @for (channel of availableNotificationChannels; track channel.id) {
                                <mat-option [value]="channel.id">
                                    {{ channel.name }} · {{ "PROJECTS.NotificationChannelType." + channel.type | translate }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (!hasProjectNotificationChannels) {
                            <mat-hint>{{ "ALARM.NotificationChannelsEmpty" | translate }}</mat-hint>
                        }
                    </mat-form-field>
                }
            </div>

            <!-- <mat-label color="warn" *ngIf="eventForm.errors?.timeOrderError">{{
      'EVENTS.EventTimeError' | translate
    }}</mat-label> -->
        </form>
    </mat-dialog-content>
</div>
